class Timer {
  private callback: Function;

  private delay: number;

  private timerId: number | null;

  private start: number;

  private remaining: number;

  constructor(callback: Function, delay: number) {
    this.callback = callback;
    this.delay = delay;

    this.timerId = null;
    this.start = Date.now();
    this.remaining = this.delay;
  }

  public pause(): void {
    window.clearTimeout(this.timerId);
    this.timerId = null;
    this.remaining -= Date.now() - this.start;
  }

  public stop(): void {
    window.clearTimeout(this.timerId);
    this.timerId = null;
  }

  public resume(): void {
    if (this.timerId) return;

    this.start = Date.now();
    this.timerId = window.setTimeout(this.callback, this.remaining);
  }

  public init(): void {
    // reset
    this.timerId = null;
    this.start = Date.now();
    this.remaining = this.delay;

    // init
    this.timerId = window.setTimeout(this.callback, this.delay);
  }
}

export default (callback: Function, delay: number): Timer => new Timer(callback, delay);
